import React from 'react';
import { Body, palettes, SmallBody, Theme } from '@indigo-ag/component-module';

import { createStylesHook } from 'shared';

interface ComponentProps {
  title?: string | React.ReactNode;
  content?: string;
  classes?: {
    container?: string;
    title?: string;
  };
}

const useStyles = createStylesHook<Theme>((theme: Theme) => ({
  container: {
    minHeight: 45,
    marginBottom: 18
  },

  minWidth130: {
    minWidth: 130
  },

  content: {
    color: palettes.brand.gray['900'],
    whiteSpace: 'break-spaces',
    textAlign: 'justify'
  },

  title: {
    color: `${palettes.brand.gray[700]} !important`,
    width: 100
  }
}));

export const SingleRow: React.FunctionComponent<ComponentProps> = ({ title, children, content, classes }) => {
  /**
   * Styles
   */
  const internalClasses = useStyles();

  return (
    <div
      className={`flex align-items-center ${internalClasses.container} ${classes?.container ? classes.container : ''}`}
    >
      <div className={`flex align-items-center ${internalClasses.minWidth130}`}>
        {typeof title === 'string' ? (
          <SmallBody
            className={`text-transform-capitalize ${internalClasses.title} ${classes?.title ? classes.title : ''}`}
          >
            {title}
          </SmallBody>
        ) : (
          title
        )}
      </div>
      {content ? <Body className={internalClasses.content}>{content}</Body> : children}
    </div>
  );
};
